module.exports = __webpack_public_path__ + "assets/img/driver-btn-2a596c7e.png";